$(document).ready(function () {
    function window_inner_height(){
        let header_height = ($('.announcement-bar-section').length > 0)? $('.section-header').outerHeight() + $('.announcement-bar-section').outerHeight() : $('.section-header').outerHeight();
        $('html').css('--window-height',($(window).height() - header_height + 'px'));
    }
    window_inner_height();
    $(window).on('resize',function(){
        window_inner_height();
    });


    // ------------------ Header
    $('#menu-drawer-close').click(function(e){
        e.preventDefault();
        $('#Details-menu-drawer-container .header__icon--menu').click();
    });

    $('#header__icon--search').click(function(e){
        e.preventDefault();
        $('#header__search').addClass('open_search');
    });

    $('#search-modal__close-button,#header__search .modal-overlay').click(function(e){
        e.preventDefault();
        $('#header__search').removeClass('open_search');
    });
    // ------------------ Header

    // ------------------ Footer
    $('.footer .footer-block .footer-block__heading').click(function(){
        if($(window).width() < 750){
            $(this).toggleClass('active');
            $(this).next('.footer-block__details-content').slideToggle();
        }
    });
    $('#scroll-to-top').on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 1000);
    });
    // ------------------ Footer


    // ------------------ wishlist
    var wishlist_storage = JSON.parse(localStorage.getItem("wishlist"));
    if (wishlist_storage === null) {
        wishlist_storage = [];
        localStorage.setItem("wishlist", JSON.stringify(wishlist_storage));
    }

    var get_wish_list = JSON.parse(localStorage.getItem("wishlist"));
    header_wishlist_update(get_wish_list.length);

    function header_wishlist_update(count){
        $(".header .header__icon--wishlist .wishlist-count-bubble").text(count);
    }

    function wishlist_icon() {
        var wishlist_i = JSON.parse(localStorage.getItem("wishlist"));
        for (var i = 0; i < wishlist_i.length; i++) {
            $(".wishlist-btn").each(function (e) {
                if ($(this).data("handle") == wishlist_i[i]) {
                    $(this).addClass("active");
                }
            });
        }
    }
    wishlist_icon();
    
    $(document).on('click', '.wishlist-btn', function (e) {
        e.preventDefault();
        $(this).toggleClass("active");
        var data = $(this).data("handle");
        var storage = JSON.parse(localStorage.getItem("wishlist"));
        storage.indexOf(data) === -1 ? storage.push(data) : storage.splice(storage.indexOf(data), 1);
        localStorage.setItem("wishlist", JSON.stringify(storage));
        
        var get_for_count = JSON.parse(localStorage.getItem("wishlist"));
        header_wishlist_update(get_for_count.length);
        if($(this).hasClass('wishlist_page_card-btn')){
            $(this).parents('.wishlist-card-wrap').fadeOut();
            if (get_for_count.length == 0) {
                $(".main-wishlist").addClass('empty-wishlist');
            } else {
                $(".main-wishlist").removeClass('empty-wishlist');
            }
        }
    });
        
    if ($(".main-wishlist").length) {
        var wishlist__count = 0;
        $(get_wish_list).each(function(i, item) {
            wishlist__count++;
            fetch(`/products/${item}?view=wishlist-card`)
            .then(responseText => responseText.text())
            .then((responseText)=>{
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                $('.main-wishlist .wishlist_product-grid').append($(html).find('.wishlist-card-wrap'));
                wishlist_icon();
            });
        });
        if (get_wish_list.length == 0) {
            $(".main-wishlist").addClass('empty-wishlist');
        } else {
            $(".main-wishlist").removeClass('empty-wishlist');
        }
    }
    // ------------------ wishlist


    // ------------------ Contact Form
    if($('#ContactForm').length > 0){
        $('#ContactForm').on('submit', function (e) {
            if (!$('#contact-terms-condition-agree').is(':checked')) {
                e.preventDefault();
                $('#terms-error').show();
                $('#contact-terms-condition-agree').focus();
            } else {
                $('#terms-error').hide();
            }
        });
    }
    // ------------------ Contact Form


    // ------------------ facet accordion
    $(document).on('click','[data-facet-toggle]',function(e){
        e.preventDefault();
        $(this).parents('[data-facet-details]').toggleClass('active');
        $(this).parents('[data-facet-details]').find('[data-facet-content]').slideToggle();
    });
    // ------------------ facet accordion


    // ------------------ Product
    if($('#product__media-thumb').length > 0){
        window.product__media_thumb = new Swiper('#product__media-thumb',{
            slidesPerView: 3,
            spaceBetween: 10,
            mousewheel:{
                forceToAxis: true
            }
        });

        window.product__media_main = new Swiper('#product__media-main',{
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            thumbs: {
                swiper: product__media_thumb,
            },
            navigation: {
                prevEl: "#product__media-main .swiper-button-prev",
                nextEl: "#product__media-main .swiper-button-next",
            },
            mousewheel:{
                forceToAxis: true
            }
        });
    }

    if($('.product__accordion-details').length > 0){
        $('.product__accordion-toggle').click(function(){
            $(this).parents('.product__accordion').siblings('.product__accordion').find('.product__accordion-details.active').removeClass('active').find('.product__accordion-content').slideUp();
            $(this).next('.product__accordion-content').slideToggle();
            $(this).parents('.product__accordion-details').toggleClass('active');
        });
    }
    // ------------------ Product
});